module.exports = __webpack_public_path__ + "static/img/JA.a867740.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/JA.png
// module id = j6kX
// module chunks = 1